import { useMutation } from '@tanstack/react-query';
import { MasterMedicine } from '../types';
import { createMasterMedicine } from '../requests';

type CreateMasterMedicine = (data: MasterMedicine) => Promise<MasterMedicine>;

interface UseCreateMasterMedicineReturn {
  createMasterMedicine: CreateMasterMedicine;
  isLoading: boolean;
}

export const useCreateMasterMedicine = (): UseCreateMasterMedicineReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (masterMedicine: MasterMedicine) => createMasterMedicine(masterMedicine)
  });

  const createMasterMedicineCallback = async (masterMedicine: MasterMedicine) => {
    const response = await mutateAsync(masterMedicine);
    return response.data.data;
  };

  return {
    createMasterMedicine: createMasterMedicineCallback,
    isLoading
  };
};
